import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getApiClient } from '@signalvote/api-client';
import type { CampaignUserDto, SetPurchaserRequest } from '@signalvote/shared';
import { queryKeys } from '@/lib/queryKeys';

const api = getApiClient();

export function useSetPurchaser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ userId, ...request }: SetPurchaserRequest & { userId: string }) => api.purchasers.set(userId, request),
    onSuccess: (purchaser) => {
      queryClient.setQueriesData<CampaignUserDto[]>({ queryKey: queryKeys.volunteers.all }, (old) =>
        Array.isArray(old)
          ? old.map((row) =>
              row.userId === purchaser.userId
                ? { ...row, isPurchaser: purchaser.isPurchaser, purchaserVersion: purchaser.purchaserVersion }
                : row,
            )
          : old,
      );
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: queryKeys.volunteers.all }),
  });
}
